import styled from "styled-components";
import PromocionesViewer from "../../../../components/PromocionesViewer";
import { usePromocionesMock } from "../../../../hooks/usePromocionesMock";

export const ComunicacionMobileTab = () => {
    const { promociones, markAsRead } = usePromocionesMock();

    return (
        <MobileContainer>
            <MobileHeader>
                <h2>Novedades</h2>
                <p>Mantente al día con las últimas novedades, promociones y mensajes para tu tienda.</p>
            </MobileHeader>
            <PromocionesViewer promociones={promociones} onMarkAsRead={markAsRead} />
        </MobileContainer>
    );
};

const MobileContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const MobileHeader = styled.header`
    padding: 18px 16px 16px;

    h2 {
        margin: 0 0 6px;
        font-size: 20px;
        font-weight: 700;
        color: #111;
    }

    p {
        margin: 0;
        font-size: 14px;
        line-height: 1.4;
        color: #444;
    }
`;
